import React from "react";
import FinishButton from "../FinishButton/FinishButton";

function Step4() {
  return (
    <div className="mm-finish">
      <img
        src={process.env.PUBLIC_URL + "/img/finish.svg"}
        alt=""
        className="mm-finish__logo"
      />
      <div className="mm-finish__text1">Спасибо!</div>
      <div className="mm-finish__text2">
        Ура! Вы успешно заполнили заявку на участие в Креативной лаборатории, на
        вашу электронную почту с минуту на минуту придет подтверждение.
      </div>
      <a href="https://t.me/travelcreate" target="_blank" rel="noreferrer">
        <FinishButton
          className="mm-finish__tg"
          text="вступить в телеграм-чат участников"
        />
      </a>
    </div>
  );
}

export default Step4;
